module.exports = __webpack_public_path__ + "static/q3-f7d61e7f952adb3caa8a4df56ea46d2b.svg";